import { ThemeType } from '../types';

export function preferLightTheme(enabled = true) {
  if (!enabled) return {};
  return { 'data-theme': ThemeType.light };
}

export function preferDarkTheme(enabled = true) {
  if (!enabled) return {};
  return { 'data-theme': ThemeType.dark };
}
